import {
  authHeader,
  config,
  options,
  handleResponse,
  handleError,
} from "../../common/helpers";

const userNotificationService = {
  fetchUserNotifications,
  bulkMarkReadNotification,
  bulkMarkDeleteNotification,
};

function fetchUserNotifications(params) {
  const userId = params.userId;
  const offset = params.offset;
  const count = params.count;
  const notifType = params.notifType;
  const ifModifiedSince = params.ifModifiedSince;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const serviceurl = options(
    config.flukeIotApiUrl +
      "/user/" +
      userId +
      "/notifications" +
      "?offset=" +
      offset +
      "&count=" +
      count +
      "&notifType=" +
      notifType +
      "&ifModifiedSince=" +
      ifModifiedSince
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function bulkMarkReadNotification(params) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const serviceurl = options(config.flukeIotApiUrl + "/notifications/bulkRead");
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function bulkMarkDeleteNotification(params) {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const serviceurl = options(
    config.flukeIotApiUrl + "/notifications/bulkDelete"
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

export default userNotificationService;
